<template>
  <button
    class="flex items-center justify-between bg-bkk-50 text-regular rounded-full px-3 py-1 pr-[5px] hover:bg-bkk-75 transition min-w-52"
  >
    <span>{{ label }}</span>
    <span
      class="ml-4 bg-white rounded-full p-1 flex items-center justify-center"
    >
      <component :is="icon" class="h-6 w-6" />
    </span>
  </button>
</template>

<script setup lang="ts">
defineProps<{
  label: string;
  icon: any;
  iconPosition?: "left" | "right";
  active?: boolean;
}>();
</script>
